import RouterViewBody from '~/views/RouterViewBody.vue'
import store from '~/store/index.js'
const interfaceGroups = store.getters['interfaceGroup/interfaceGroupIdList']
export default [
  {
    path: 'mail',
    component: RouterViewBody,
    meta: {
      breadCrumb: 'Mail',
    },
    children: [
      {
        path: '',
        name: 'settingInterfaceMail',
        component: () => import('~/views/settingPage/interface/settingInterfaceMail.vue'),
      },
      {
        path: 'invite',
        name: 'settingInterfaceMail_invite',
        redirect: {
          name: 'settingInterfaceMail',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'email',
          breadCrumb: (translation) =>
            translation.pages['mail_invite'].titles['priglashenie-v-proapp'],
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceMob_invite_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.invite.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'text',
            name: 'settingInterfaceMob_invite_text',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.invite.text,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.texts,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_invite_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.invite.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },

          {
            path: 'footer',
            name: 'settingInterfaceMob_invite_footer',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.invite.footer,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.footer,
            },
          },
        ],
      },
      {
        path: 'password',
        name: 'settingInterfaceMail_password',
        redirect: {
          name: 'settingInterfaceMail',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'email',
          breadCrumb: (translation) =>
            translation.pages['mail_password'].titles['vosstanovleniya-parolya-v-proapp'],
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceMob_password_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.password.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'text',
            name: 'settingInterfaceMob_password_text',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.password.text,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.texts,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_password_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.password.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },

          {
            path: 'footer',
            name: 'settingInterfaceMob_password_footer',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.password.footer,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.footer,
            },
          },
        ],
      },
      {
        path: 'price-offer',
        name: 'settingInterfaceMail_price-offer',
        redirect: {
          name: 'settingInterfaceMail',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'email',
          breadCrumb: (translation) => translation.pages['mail_offer'].titles['main'],
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceMail_price-offer_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.offer.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMail_price-offer_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.offer.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },

          {
            path: 'footer',
            name: 'settingInterfaceMail_price-offer_footer',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mail.offer.footer,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.footer,
            },
          },
        ],
      },
      {
        path: 'report-sign',
        name: 'settingInterfaceMail-report_sign',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          interfaceGroupId: interfaceGroups.mail.report_sign.fields,
          breadCrumbLocalStorage: 'email',
          breadCrumb: (translation) => translation.pages.report_signe.fields['for_signature'],
        },
      },
    ],
  },
]
